module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvY29zdGFsLTYtMi42Mzk0Mzc2My5qcGciOw=="